const ECID_PATTERN = /^[0-9]{38}$/;
const IDENTITY_WAIT_MS = 200;

const toContext = value => (typeof value === 'string' && ECID_PATTERN.test(value)
  ? { ecid: value } : undefined);

const getAdobeVisitorContext = async () => {
  // Do not bypass SDK consent by sending an identifier left in browser storage.
  if (typeof window.alloy !== 'function') return undefined;
  let timeout;
  try {
    const identity = await Promise.race([
      Promise.resolve(window.alloy('getIdentity', { namespaces: ['ECID'] })).catch(() => undefined),
      new Promise(resolve => {
        timeout = window.setTimeout(() => resolve(undefined), IDENTITY_WAIT_MS);
      }),
    ]);
    return toContext(identity?.identity?.ECID);
  } catch {
    return undefined;
  } finally {
    window.clearTimeout(timeout);
  }
};

export default getAdobeVisitorContext;
